import * as React from 'react';
import styled from 'styled-components';
import {COLORS, focusStyles} from '../styles';
import { Size, Testable } from '../types';
import { SystemIcons } from '../icons';
import { ComponentTextStyle, ComponentSStyling, ComponentXSStyling } from '../styles';
import {defaultOnMouseDownHandler} from '../common';

const BackButtonContainerStyles = styled.button<BackButtonProps>`
  box-sizing: border-box;
  min-height: 48px;
  padding: 0;
  margin: 0;
  outline:none;
  max-width: max-content;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;

  ${(props) => (props.size === Size.XSmall ? ComponentXSStyling(ComponentTextStyle.Bold, COLORS.neutral_600) : ComponentSStyling(ComponentTextStyle.Bold, COLORS.neutral_600))};
  font-feature-settings: 'liga' off;

  & > .button-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    max-width: max-content;
    padding: 4px 4px 4px 0;
    border-radius: 4px;
    cursor: inherit;
    min-width: 64px;

  }

  & > .button-content > span {
    display: flex;
    cursor: inherit;
  }
  & > .button-content > label {
    display: flex;
    cursor: inherit;
    flex-grow: 1;
    justify-content: center;
  }

  &:hover > .button-content,
  &.hover-state > .button-content {
    background-color: ${COLORS.primary_20};
    color: ${COLORS.primary_700};
  }
  &:focus > .button-content,
  &.focus-state > .button-content {
    ${focusStyles}
  }
  &:active > .button-content,
  &.active-state > .button-content {
    background-color: ${COLORS.primary_100};
    color: ${COLORS.primary_800};
  }
  &:disabled {
    cursor: not-allowed;
  }
  &:disabled > .button-content {
    color: ${COLORS.neutral_300} !important;
    background-color: transparent !important;
  }
`;

export interface BackButtonProps extends Testable, React.ButtonHTMLAttributes<HTMLButtonElement> {
  size: Size.Small | Size.XSmall;
  disabled?: boolean;
}
const BackButton: React.FunctionComponent<BackButtonProps> = ({ children, size = Size.Small, dataTestId, ...props }) => {
  return (
    <BackButtonContainerStyles {...props} size={size} onMouseDown={defaultOnMouseDownHandler} dataTestId={dataTestId}>
      <div className={'button-content'}>
        <span aria-hidden="true">
          <SystemIcons.ArrowLineLeft size={size === Size.XSmall ? '20' : '24'} />
        </span>
        <label>{children}</label>
      </div>
    </BackButtonContainerStyles>
  );
};

export default BackButton;
